export default __webpack_public_path__ + "locales/de/Ldap.json?hash=ce7e73e29b09ab9ebcc3a121e4d23b93";